import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductDescriptionStyles;
    isProductSample?: boolean;
}

type Props = OwnProps;

export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
}

export const productDescriptionStyles: ProductDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
            span {
                color: black !important;
            }
        `,
        typographyProps: {
            size: 20,
            weight: 500,
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
            `,
        },
    },
};

const ProductDescription = ({ product,isProductSample, onClick, extendedStyles }: Props) => {
    const [styles] = useState(() => mergeToNew(productDescriptionStyles, extendedStyles));

    const getProductPath = (): string => {
        let path = "product" in product ? product.productInfo.productDetailPath : product.productUri;
        if (isProductSample) {
            path = path.split("?")[0];
        }
        return path;
    };

    const description =
        "product" in product
            ? 
            (product as any).product?.productName || product.product.productTitle
            : product.productName || product.shortDescription || ("description" in product ? product.description : "");

    const productDetailPath = getProductPath();

    return (
    <Link 
    	{...styles.productDetailLink} 
    	href={productDetailPath} 
        onClick={onClick}
    	data-test-selector="productDescriptionLink"
    >
        {description}
    </Link>);        
};

export default ProductDescription;
